module.exports = __webpack_public_path__ + "static/media/charlene.234d8478.jpeg";